var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"function-button",class:_vm.className,style:({
    left: _vm.propLeft,
    top: _vm.propTop,
    right: _vm.propRight,
    bottom: _vm.propBottom,
    width: _vm.propWidth,
    height: _vm.propHeight,
  })},[_vm._t("icon")],2)}
var staticRenderFns = []

export { render, staticRenderFns }